export interface CreditoConSaldo {
    id: number;
    codiceTributo: string;
    codiceFiscale: string;
    anno: number;
    dataInizioUtilizzo: Date;
    dataFineUtilizzo: Date;
    saldo: number;
    importo: number;
    sezioneTributo: TipoSezioneF24;
    descrizione: string; // Proprieta creata dal client incrociando la stessa di CodiceTributo
}

export interface Credito {
    id: number;
    contribuentiCodiceFiscale: string;
    codiceTributo: string;
    anno: number;
    importo: number;
    dataInizioUtilizzo: Date;
    dataFineUtilizzo: Date;
    datiExtra: CreditoDatiExtra;
    annotazioni: string;
    mese: number;
    periodoDiRiferimentoDa: Date;
    periodoDiRiferimentoA: Date;
    riferimento: string;
}

export interface CreditoDatiExtra {
    codiceSede: string;
    codiceEnte: string; // (CodiceComune/CodiceProvincia/CodiceRegioneProvinciaAutonoma)
    matricolaInps: string;
    codiceDitta: string;
    cc: string;
}

export interface CreditoUtilizzato {
    anno: number;
    codiceFiscale: string;
    codiceTrbuto: string;
    importo: number;
    descrizione: string;
    data: Date;

    scadenzaId?: string;
    versamentoId?: string;
    dataScadenza?: Date;

    protocolloTelematico?: string;
    f24PagamentoId?: string;
    dataPagamento?: Date;

    annoRedditiCompensazioneInDichiarazione?: number;
    dataConfermaUnico?: Date;
}

export interface CodiceTributo {
    codice: string;
    descrizione: string;
    sezioneF24: SezioniF24;
    modalitaCompilazioneCrediti: CompilazioneCrediti;
    modalitaIdentificazioneCredito: IdentificazioneCrediti;
    creditoManuale: boolean;
}

export enum SezioniF24 {
    Erario = 0,
    Inps = 1,
    Regioni = 2,
    Imu = 3,
    Inail = 4,
    AltriEnti = 5,
}

export enum IdentificazioneCrediti {
    PerAnno = 0, //Utilizza solamente i campi codice tributo ed anno per garantire l'univocita'
    PerAnnoAndMese = 1, //Utilizza i campi codice tributo, anno, mese per garantire l'univocita'
    PerPeriodoRiferimentoDaA = 2, //Utilizza i campi codice tributo, anno, daMese, daAnno, aMese, aAnno per garantire l'univocita'
    PerPeriodoRiferimentoSoloDa = 3, //Utilizza i campi codice tributo, anno, daMese, daAnno per garantire l'univocita'
    PerRiferimento = 4, //Utilizza i campi codice tributo e riferimento (VEDI INAIL)
}

export enum CompilazioneCrediti {
    No = 0,
    Rateazione0101 = 1,
    RateazioneMensile = 2, // in F24 si chiama Rateazione (il valore va in Crediti.Mese)
    InpsSoloDa = 4, // in F24Inps si chiama PeriodoDiRiferimentoDal
    InpsDaA = 8, // in F24Inps si chiama PeriodoDiRiferimentoDa e PeriodoDiRiferimentoA
    MatricolaInps = 16,
    CodiceSedeInps = 32,
    CodiceComune = 64,
    CodiceProvincia = 128,
    CodiceRegioneProvinciaAutonoma = 256,
    DatiInail = 512, // CodiceSede, CodiceDitta, CC
}

export enum TipoSezioneF24 {
    Erario = 0,
    Inps = 1,
    Regioni = 2,
    ImuAndTributiLocali = 3,
    Inail = 4,
    AltriEntiPrevidenziali = 5,
    Accise = 6,
}

export namespace CompilazioneCrediti {
    export function hasFlag(compilazioneCrediti: CompilazioneCrediti, flag: CompilazioneCrediti): boolean {
        return (compilazioneCrediti & flag) === flag;
    }
}
